import React, { useCallback, useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import scrollIntoView from "scroll-into-view";
export const ContentsItemContainer = (props) => {
  const { children, id } = props;
  return (
    <div id={id} className="scroll-block" style={{ height: "fit-content" }}>
      {children}
    </div>
  );
};
export const SideContents = (props) => {
  const { navList } = props;
  const isWindow = () => typeof window !== "undefined";
  const [documrntScrollTop, setDocumrntScrollTop] = useState();
  const [contentheight, setContentheight] = useState(0);
  const [scrollBlocks, setScrollBlocks] = useState([]);
  const [currentKey, setCurrentKey] = useState(navList[0].key);
  const handleScroll = (id) => {
    const el = document.querySelector(`#${id}`);
    scrollIntoView(el, {
      time: 300,
      align: {
        top: 0,
        topOffset: 70,
      },
    });
  };

  const scrollHandler = useCallback(() => {
    if (isWindow()) {
      const scrollTop = document.documentElement.scrollTop;
      setDocumrntScrollTop(scrollTop);
      scrollBlocks.forEach((scrollBlock) => {
        // 300：设置变换位置
        if (scrollTop >= scrollBlock.offsetTop - 500) {
          setCurrentKey(scrollBlock.id);
        }
      });
    }
  }, [scrollBlocks]);
  const reloadElement = () => {
    const rightContentheight = document.querySelector(".right-box")
      .offsetHeight;
    setContentheight(rightContentheight);
    const scrollBlocksDom = document.querySelectorAll(".scroll-block");
    const scrollBlocks = Array.from(scrollBlocksDom).map((item, index) => {
      // top 数组值  和 nav 的 key 连接起来，
      return { offsetTop: item.offsetTop, id: item.id };
    });
    setScrollBlocks(scrollBlocks);
  };
  if (isWindow()) {
    window.onresize = () => {
      reloadElement();
    };
    useEffect(() => {
      reloadElement();
    }, []);
  }
  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
  }, [documrntScrollTop, scrollHandler]);

  const clsContentsBox = isWindow()
    ? classNames({
        "application-contents-box": true,
        fixed: documrntScrollTop > 580 && documrntScrollTop <= contentheight,
        relative: documrntScrollTop > contentheight,
      })
    : "application-contents-box";

  return (
    <div className="application-contents-warp">
      <div className={clsContentsBox}>
        <div className="application-contents">
          {navList.map((item, index) => {
            const clsContentsItem = classNames({
              "contents-item": true,
              checked: currentKey === item.key,
            });
            return (
              <>
                <div
                  key={index}
                  className={clsContentsItem}
                  onClick={() => {
                    handleScroll(item.key);
                    setCurrentKey(item.key);
                  }}
                >
                  {item.label}
                </div>
                {item.children &&
                  item.children.map((child, keyIndex) => {
                    const clsContentsItem = classNames({
                      "contents-subitem": true,
                      checked: currentKey === child.key,
                    });
                    return (
                      <div
                        className={clsContentsItem}
                        key={keyIndex}
                        onClick={() => {
                          handleScroll(child.key);
                          setCurrentKey(child.key);
                        }}
                      >
                        {child.label}
                      </div>
                    );
                  })}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};
